// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Unsafe_Reference from "../Unsafe.Reference/index.js";
var Optional = function (x) {
    return x;
};
var some = Optional;
var isSome = function (opt) {
    return !Unsafe_Reference.unsafeRefEq(opt)($foreign.none);
};
var fromSome = function (v) {
    if (isSome(v)) {
        return v;
    };
    if (Data_Boolean.otherwise) {
        return Partial_Unsafe.unsafeCrashWith("Optional.fromSome: none");
    };
    throw new Error("Failed pattern match at Specular.Internal.Incremental.Optional (line 24, column 1 - line 24, column 38): " + [ v.constructor.name ]);
};
export {
    none
} from "./foreign.js";
export {
    some,
    isSome,
    fromSome
};
